// "By the numbers" counters: count up once the section scrolls into view.

const DURATION = 1200;

export default function counters() {
    const numbers = Array.from(document.querySelectorAll('[data-amu-count]'));

    if (!numbers.length) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)) {
        return; // the final value is already in the markup
    }

    function run(element) {
        // The number comes from a theme setting as typed, e.g. "10,870" or
        // "95%". Animate its digits and keep any text either side of them.
        const parts = element.textContent.trim().match(/^(\D*)(\d[\d,]*)(.*)$/);

        if (!parts) {
            return;
        }

        const [, prefix, digits, suffix] = parts;
        const target = parseInt(digits.replace(/,/g, ''), 10);
        const grouped = digits.includes(',');
        const start = performance.now();

        function step(now) {
            const progress = Math.min((now - start) / DURATION, 1);
            // Ease out so the count decelerates into its final value.
            const eased = 1 - Math.pow(1 - progress, 3);
            const value = Math.round(target * eased);
            element.textContent = prefix + (grouped ? value.toLocaleString('en-US') : value) + suffix;

            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        }

        window.requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                run(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.4 });

    numbers.forEach((element) => observer.observe(element));
}
